export const VehicleTypesPath = {
  base: 'vehicle-types'
};
